<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col class="card-col">
          <div class="row card-row-bg card-row wrap">
            <div
              v-for="(card, index) in parentCategory.noPDI"
              :key="index"
              :ref="`card_${index}`"
              @mouseover="hoverCard(index)"
              @mouseout="hoverCard(-1)"
              @click="category(card)"
              class="card"
            >
              <div>
                <img
                  class="card-image"
                  :class="{ selected: isSelected(index) }"
                  @load="onLoaded"
                  @error="onImageLoadFailure($event)"
                  v-show="loaded"
                  :src="urlImage + card.name + '.png'"
                />

                <img
                  class="card-image"
                  v-show="loaded == false"
                  src="@/assets/loader.gif"
                />
              </div>

              <div class="card-footer">
                <h3 class="card-text">{{ card.name }}</h3>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "categories",

  components: {},

  data() {
    return {
      selectedCard: -1,
      loaded: false,
      urlImage:
        "https://risoulimages.s3.us-west-2.amazonaws.com/IMAGENES+NIVELES/NoPDI/GRAL/",
    };
  },

  props: {
    parentCategory: { type: Object },
    sendSnack: { type: Function },
  },

  methods: {
    category: function (item) {
      var select = item.name;
      var idSelected = item.id;
      this.$router.push(
        `/category/${encodeURIComponent(select)}?idCategory=${idSelected}`
      );
    },

    hoverCard(selectedIndex) {
      this.selectedCard = selectedIndex;
    },

    isSelected(cardIndex) {
      return this.selectedCard === cardIndex;
    },

    onLoaded() {
      this.loaded = true;
    },

    onImageLoadFailure(event) {
      event.target.src =
        "https://risoulimages.s3-us-west-2.amazonaws.com/Imagenes+Items/Imagenes/GENERICA RISOUL.png";
    },
  },

  computed: {},

  watch: {},

  created() {
    document.title = "Risoul - Categorías";
  },

  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss">
.card-col > .card-row-bg > .card {
  background-color: #fafbfc !important;
}

.card-row {
  display: flex;
  justify-content: center;
  align-items: center;
}

.wrap {
  flex-wrap: wrap;
}

.card {
  position: relative;
  height: 225px;
  flex-basis: 260px;
  margin: 5px;
  background-color: var(--v-secondary-base);
  padding-top: 0px;
  overflow: hidden;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
}

.card-image {
  /* center horizontally overflown image */
  position: absolute;
  left: -9999px;
  right: -9999px;
  margin: auto;
  height: 180px;
  min-width: 100%;
}

.card-footer {
  position: absolute;
  bottom: 0;
  height: 70px;
  width: 100%;
  padding: 30.5px 0px 0px 0px;
  font-family: Helvetica;
}

.card-text {
  padding: 0 1.6rem;
  font-size: 1.2rem;
  color: #0d3a7e !important;
  text-transform: uppercase;
  text-align: center;
}

.card {
  /* the other rules */
  transition: height 0.3s, box-shadow 0.3s;
}

.card:hover {
  height: 250px;
  box-shadow: 1px 5px 23px 7px rgba(13, 58, 126, 0.54);
  cursor: pointer;
}

.card-image {
  /* the other rules */
  transition: height 0.3s, opacity 0.3s;
}

.card-image.selected {
  height: 250px;
  opacity: 0.6;
}

.card:hover > .card-footer > .card-text {
  color: #fa6b17 !important;
}
</style>
